import { useState } from "react";

const JOB_FORM_URL = "https://readdy.ai/api/form/d796mmrll6jbq2vddip0";

export default function JobSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch(JOB_FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="empleo" className="py-20 md:py-28 bg-gradient-to-br from-teal-900 to-emerald-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/a5439f0506e34a1da0a746ea1d3bde9d.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-teal-900/90 to-emerald-900/90"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Info */}
          <div>
            <span className="inline-block text-teal-300 text-sm font-semibold tracking-widest uppercase mb-4">
              Únete al Equipo
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
              ¿Quieres trabajar
              <span className="block text-teal-300">con nosotros?</span>
            </h2>
            <p className="text-white/75 text-lg leading-relaxed mb-8">
              Somos una empresa en crecimiento que valora a su equipo. Ofrecemos trabajo estable, buen ambiente y oportunidades de crecimiento.
            </p>

            <div className="flex flex-col gap-4">
              {[
                { icon: "ri-money-dollar-circle-line", title: "Pago competitivo", desc: "Salario justo y puntual" },
                { icon: "ri-time-line", title: "Horarios flexibles", desc: "Adaptamos el horario a ti" },
                { icon: "ri-team-line", title: "Buen ambiente", desc: "Equipo amigable y profesional" },
                { icon: "ri-bar-chart-line", title: "Crecimiento", desc: "Oportunidades de avanzar" },
              ].map((item) => (
                <div key={item.title} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-500/30 rounded-xl shrink-0">
                    <i className={`${item.icon} text-teal-300 text-lg`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-white text-sm">{item.title}</div>
                    <div className="text-white/60 text-xs">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Form */}
          <div>
            {submitted ? (
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-400 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">¡Aplicación enviada!</h3>
                <p className="text-white/70">
                  Gracias por tu interés en unirte a Jek Cleaning Service. Nos pondremos en contacto contigo pronto.
                </p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="job-form"
                onSubmit={handleSubmit}
                className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 flex flex-col gap-5"
              >
                <h3 className="text-xl font-bold text-white">Aplica ahora</h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-white/80 mb-1.5">Nombre completo *</label>
                    <input
                      type="text"
                      name="nombre"
                      required
                      placeholder="Tu nombre"
                      className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-white/80 mb-1.5">Teléfono *</label>
                    <input
                      type="tel"
                      name="telefono"
                      required
                      placeholder="(123) 456-7890"
                      className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-white/80 mb-1.5">Correo electrónico *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="tu@email.com"
                    className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-white/80 mb-1.5">Experiencia en limpieza</label>
                  <select
                    name="experiencia"
                    className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-teal-400 cursor-pointer"
                  >
                    <option value="" className="text-gray-800">Selecciona...</option>
                    <option value="Sin experiencia" className="text-gray-800">Sin experiencia (te entrenamos)</option>
                    <option value="Menos de 1 año" className="text-gray-800">Menos de 1 año</option>
                    <option value="1-2 años" className="text-gray-800">1-2 años</option>
                    <option value="Más de 2 años" className="text-gray-800">Más de 2 años</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-white/80 mb-1.5">Disponibilidad *</label>
                  <select
                    name="disponibilidad"
                    required
                    className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-teal-400 cursor-pointer"
                  >
                    <option value="" className="text-gray-800">Selecciona...</option>
                    <option value="Tiempo completo" className="text-gray-800">Tiempo completo</option>
                    <option value="Medio tiempo" className="text-gray-800">Medio tiempo</option>
                    <option value="Fines de semana" className="text-gray-800">Fines de semana</option>
                    <option value="Flexible" className="text-gray-800">Flexible</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-white/80 mb-1.5">Cuéntanos sobre ti</label>
                  <textarea
                    name="mensaje"
                    rows={3}
                    maxLength={500}
                    placeholder="¿Por qué quieres trabajar con nosotros? ¿Tienes transporte propio?..."
                    className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400 resize-none"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="bg-teal-400 hover:bg-teal-300 disabled:opacity-60 text-teal-900 font-bold py-4 rounded-xl transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 text-base"
                >
                  {loading ? (
                    <><i className="ri-loader-4-line animate-spin"></i> Enviando...</>
                  ) : (
                    <><i className="ri-send-plane-line"></i> Aplicar Ahora</>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
